import { removeHtml } from '../utils/helper'
import NewspaperModel from '../models/newspaper.model'

export default {
  beforeRouteEnter (to, from, next) {
    const data = NewspaperModel.query().find(1)
    if (!data) NewspaperModel.insert({ data: NewspaperModel.defaultValue })

    next()
  },

  data () {
    return {
      classArray: {
        0: '',
        1: 'one',
        2: 'two',
        3: 'three',
        4: 'four'
      },
      logoClass: '',
      isShowPlaceholder: true,
      tmpLogo: ''
    }
  },

  created () {
    this.updateStateLogo(this.item.logo)
    this.tmpLogo = this.item.logo || '<br>'
  },

  computed: {
    item () {
      return NewspaperModel.query().find(1) || new NewspaperModel()
    }
  },

  methods: {
    /**
     * update state when typing
     * @param text
     */
    updateStateLogo (text) {
      this.logoClass = text.length > 4 ? 'four' : this.classArray[text.length]
      this.isShowPlaceholder = !text.length || text.trim() === '<br>'
    },

    /**
     * update Logo
     */
    updateLogo (e) {
      let text = e.target.textContent

      this.updateStateLogo(text)
      this.item.logo = removeHtml(text)

      // remove html when hit Enter for one column
      if (!e.data && this.isEnter) {
        e.target.innerHTML = this.tmpLogo = removeHtml(text)
      }
    },

    /**
     * update Date
     * @param e
     */
    updateDate (e) {
      this.item.date = e.target.value
      this.item.$save()
    },

    /**
     * update Issuer
     * @param e
     */
    updateIssuer (e) {
      this.item.issuer = e.target.value
      this.item.$save()
    },

    /**
     *
     */
    submitText (e) {
      this.isEnter = e.keyCode === 13

      // keyCode = 229 for enter text
      if (e.code === 'Enter' && e.isComposing) {
        this.cutString(e)
      }
    },

    /**
     * Submit Text Logo For Mobile
     */
    submitTextHeaderMobile (e) {
      this.isEnter = e.keyCode === 13
      // keyCode = 229 for enter text
      if (e.code === 'Enter') {
        this.cutString(e)
      }
    },

    /**
     * Cut String for Logo
     * @param e
     */
    cutString (e) {
      const plainText = removeHtml(this.item.logo)
      const text = plainText.substr(0, 4)

      if (text.length >= 4) {
        setTimeout(() => {
          e.target.blur()
          e.target.innerHTML = this.tmpLogo = text.trim()
        }, 300)
      }
    }
  }
}